if (!customElements.get('wls-replacement-parts')) {
  class WLSReplacementParts extends HTMLElement {
    connectedCallback() {
      // Run after product-form's connectedCallback removes `disabled`
      setTimeout(() => this.init(), 0);
    }

    get elements() {
      return {
        variantSelects: document.querySelector('variant-selects[data-replacement-parts]'),
        submitBtn: document.querySelector('[data-replacement-parts] button[type="submit"][name="add"]'),
        tooltip: document.querySelector('.replacement-parts-tooltip'),
        gallery: document.querySelector('media-gallery[data-replacement-parts]'),
      };
    }

    attachTooltipListeners() {
      const { submitBtn, tooltip } = this.elements;
      if (!submitBtn || !tooltip) return;

      submitBtn.addEventListener('mouseenter', () => {
        if (submitBtn.hasAttribute('disabled')) tooltip.classList.add('is-visible');
      });
      submitBtn.addEventListener('mouseleave', () => {
        tooltip.classList.remove('is-visible');
      });
    }

    // After each variant change, hide any thumbnail whose corresponding main slide
    // was not part of the initial non-variant gallery. This prevents previously
    // selected variant thumbnails from accumulating visibly in the thumbnail strip.
    // The <li> element stays in the DOM so setActiveMedia() can still find it.
    cleanVariantThumbnails() {
      const { gallery } = this.elements;
      if (!gallery || !this.nonVariantMediaIds) return;

      const thumbnailStrip = gallery.querySelector('[id^="Slider-Thumbnails"]');
      if (!thumbnailStrip) return;

      const slidesList = gallery.querySelector('[id^="Slider-Gallery"]');
      const activeSlideId = slidesList?.querySelector('.is-active')?.dataset.mediaId;

      thumbnailStrip.querySelectorAll('[data-target]').forEach((thumb) => {
        const isNonVariant = this.nonVariantMediaIds.has(thumb.dataset.target);
        const isActive = thumb.dataset.target === activeSlideId;
        thumb.style.display = !isNonVariant && !isActive ? 'none' : '';
      });
    }

    init() {
      const { variantSelects, submitBtn, gallery } = this.elements;
      if (!variantSelects) return;

      const hasUrlVariant = new URLSearchParams(window.location.search).has('variant');

      // Capture initial slide IDs for thumbnail cleanup after variant changes.
      // For URL-variant pages, exclude the active (URL-variant) slide from the safe set
      // so its thumbnail is also cleaned up when the user switches to a different variant.
      if (gallery) {
        const slidesList = gallery.querySelector('[id^="Slider-Gallery"]');
        const slides = Array.from(slidesList ? slidesList.querySelectorAll('[data-media-id]') : []);

        if (hasUrlVariant) {
          const activeSlideId = slidesList?.querySelector('.is-active')?.dataset.mediaId;
          this.nonVariantMediaIds = new Set(
            slides.map((el) => el.dataset.mediaId).filter((id) => id !== activeSlideId)
          );
        } else {
          this.nonVariantMediaIds = new Set(slides.map((el) => el.dataset.mediaId));
        }
      }

      if (!hasUrlVariant) {
        // No variant in URL: clear pre-selected state and disable ATC until user picks.
        variantSelects.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = false;
          radio.removeAttribute('checked');
        });

        if (submitBtn) {
          submitBtn.setAttribute('disabled', '');
          submitBtn.setAttribute('data-rp-awaiting-variant', '');
        }

        this.attachTooltipListeners();
      }

      // Always subscribe to variant changes: clean up accumulated variant thumbnails.
      // For no-URL-variant flow, also re-attach tooltip listeners after buy-button DOM replacement.
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        setTimeout(() => {
          if (!hasUrlVariant) this.attachTooltipListeners();
          this.cleanVariantThumbnails();
        }, 0);
      });
    }
  }

  customElements.define('wls-replacement-parts', WLSReplacementParts);
}
